(function () {
	'use strict';

	function MultiagencyFormController($scope, $http) {
		$scope.agencies = [];
		$scope.matchingAgencies = [];
		$scope.selectedAgency = null;
		$scope.highlighted = null;
		$scope.submitting = false;
		$scope.submitted = false;
		$scope.errors = {};
		$scope.focused = false;
		var currentIndex = null;
		var currentArea;

		var nameReg = /^[a-zA-ZåÅäÄöÖ -]{2,30}$/;
		var emailReg = /^([\w-\+]+(?:\.[\w-\+]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
		var phoneReg = /^\+?[0-9 \-\(\)]{6,}$/;
		var numberReg = /^\d+$/;

		var errors = {
			name: 'Virheellinen nimi',
			email: 'Virheellinen sähköpostiosoite',
			phone: 'Virheellinen puhelinnumero'
		};

		$scope.getAgencies = function() {
			$http.get('/api/km/KMSite/agencySearch', {
				params: { "limit": 300 }
			}).then(function(data) {
				$scope.agencies = data.data.data.results || [];
			});
		};

		$scope.filterAgencies = function(area) {
			if (!area) {
				$scope.matchingAgencies = [];
				return;
			}

			$scope.matchingAgencies = [];

			angular.forEach($scope.agencies, function(agency, index) {
				var matching = agency.responsibleFor.filter(function(a) {
					return a.substring(0, $scope.area.length) == area;
				});

				if (matching && matching.length > 0) {
					$scope.matchingAgencies.push(agency);
				}

			});
		};


		$scope.selectAgency = function(agency) {
			if (!agency) {
				return;
			}
			$scope.selectedAgency = agency.key;
			$scope.area = "Kiinteistömaailma " + agency.marketingName;
			document.getElementById('pcode').value = "Kiinteistömaailma " + agency.marketingName;
			$scope.matchingAgencies = [];
			$scope.focused = false;

			document.getElementById('pcode').blur();
		};

		$scope.deselectAgency = function(nofocus) {
			$scope.area = '';
			$scope.selectedAgency = null;
			$scope.matchingAgencies = [];
			$scope.focused = false;
			currentArea = null;
			
			if (!nofocus) {
				document.getElementById('pcode').focus();
			}
		};

		$scope.handleKeyUp = function(event) {
			var area = event.target.value;
			var key = event.keyCode || event.which;

			if (currentArea !== area && numberReg.test(area)) {
				$scope.filterAgencies(area);
				currentIndex = 0;
				if ($scope.matchingAgencies.length > 0) {
					$scope.highlighted = $scope.matchingAgencies[0].key;
				}
			}
			currentArea = area;
		};

		$scope.handleKeypress = function(event) {	
			var key = event.keyCode || event.which;

			if (!$scope.matchingAgencies.length) {
				return;
			}
			
			if (key == 38) {
				// event.preventDefault();
				if (currentIndex === 0 || !currentIndex) {
					currentIndex = $scope.matchingAgencies.length - 1;
				} else {
					currentIndex -= 1;
				}
			}
			else if (key == 40) { /* go down */
				// event.preventDefault();
				if ((!currentIndex || currentIndex >= $scope.matchingAgencies.length - 1) && currentIndex !== 0) {
					currentIndex = 0;
				} else {
					currentIndex += 1;
				}
			}
			else if (key == 13) { /* enter */
				$scope.selectAgency($scope.matchingAgencies[currentIndex]);
			}
			else if (key == 27) { /* esc */
				currentIndex = null;
				$scope.area = '';
				$scope.matchingAgencies = [];
				$scope.highlighted = null;
				document.getElementById('pcode').blur();
			}

			if ($scope.matchingAgencies[currentIndex]) {
				$scope.highlighted = $scope.matchingAgencies[currentIndex].key;
			}
		};

		$scope.submitForm = function() {
			$scope.errors = {};

			if (Utils) {
				Utils.ScrollTo('.multiagency-form', 100);
			}

			if (!$scope.selectedAgency || !$scope.area) {
				$scope.errors.area = "Valitse myymälä";
			}

			if (!$scope.name) {
				$scope.errors.name = 'Syötä nimi';
			}
			else if ($scope.name && !nameReg.test($scope.name)) {
				$scope.errors.name = 'Virheellinen nimi';
			}

			if (!$scope.email) {
				$scope.errors.email = 'Syötä sähköpostiosoite';
			} 
			else if ($scope.email && !emailReg.test($scope.email)) {
				$scope.errors.email = 'Virheellinen sähköpostiosoite';
			}

			if ($scope.phone && !phoneReg.test($scope.phone)) {
				$scope.errors.phone = 'Virheellinen puhelinnumero';
			}

			if (!angular.equals($scope.errors, {})) {
				return;
			}

			var formParams = {
				name: $scope.name,
				email: $scope.email,
				phone: $scope.phone || '',
				agency: $scope.selectedAgency || '',
				submitUrl: window.location.href,
				message: $scope.message || '',
				subjectIndex: 1
			};

			if (window.wakeTestEmail !== undefined) {
				formParams.wakeTestEmail = window.wakeTestEmail;
			}

			$scope.submitting = true;

			$http({
				method: "POST",
				url: "/api/km/KMSite/contactForm",
				data: formParams
			}).then(function () {
				$scope.errors = {};
				$scope.submitting = false;
				$scope.submitted = true;

				setTimeout(function () {
					$scope.name = '';
					$scope.phone = '';
					$scope.email = '';
					$scope.area = '';
					$scope.selectedAgency = null;
					$scope.message = '';

					$scope.submitted = false;

					$scope.$apply();
				}, 8000);

				if (_gaq || window._gaq) {
					_gaq.push(['_trackEvent', 'Ota yhteyttä yleisesti', 'Lähetä']);
				}
			},
				function (results) {
					$scope.submitting = false;

					for (var key in results.data.data) {
						if (!results.data.data[key].success) {
							$scope.errors[key] = errors[key];
						} else {
							$scope.errors[key] = null;
						}
					}
				});
		};

		document.getElementById('pcode').addEventListener('blur', function() {
			$scope.focused = false;
			if (!$scope.selectedAgency) {
				$scope.area = '';
			}
		});
	}

	MultiagencyFormController.$inject = ['$scope', '$http'];

	angular.module('KimaMain').controller('MultiagencyFormController', MultiagencyFormController);

})();